import { createSelector } from '@reduxjs/toolkit';
import { alphaSort } from 'vet-bones/utils';

import { isMapping } from 'src/containers/ProjectDiagram/utils/data';
import { memoizeSelectorFactory } from 'src/selectors/memoizeSelectorFactory';
import {
  prevProjectLinkDataArraySelector,
  projectLinkDataArraySelector,
} from 'src/selectors/projectLinkDataArray';

export const projectMappingsSelector = memoizeSelectorFactory(
  (projectId: string) =>
    createSelector(projectLinkDataArraySelector(projectId), (linkDataArray) =>
      linkDataArray.filter(isMapping).sort(alphaSort((mapping) => mapping.text))
    )
);

export const prevProjectMappingsSelector = memoizeSelectorFactory(
  (projectId: string) =>
    createSelector(
      prevProjectLinkDataArraySelector(projectId),
      (linkDataArray) =>
        linkDataArray
          .filter(isMapping)
          .sort(alphaSort((mapping) => mapping.text))
    )
);
